"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationHeaderContainer = exports.LocationAddressRow = exports.LocationPhoneAnchor = exports.LocationInfoItem = exports.LocationRow = exports.LocationWrapper = exports.LocationsList = exports.MapLoading = exports.MapContainerInner = exports.MapContainer = exports.LocationsSectionHeader = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const dot_spacer_styles_1 = require("../../lib/styles/dot-spacer.styles");
exports.LocationsSectionHeader = styled_1.default.h2 `
  margin: 0;
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.MapContainer = (0, styled_1.default)('div', {
    shouldForwardProp: (prop) => prop !== 'height'
}) `
  margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  width: 100%;
  padding-top: 33.3%;
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius_medium')};
  overflow: hidden;
  position: relative;
  ${({ height }) => height != null
    ? `height: ${typeof height === 'string' ? height : `${height}px`};`
    : ''};
`;
exports.MapContainerInner = styled_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  > div {
    width: 100%;
    height: 100%;
  }
`;
exports.MapLoading = styled_1.default.div `
  border-radius: 2px;
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${(0, ui_theme_1.fromTheme)('color_background_secondary')};
  background: linear-gradient(
    to right,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 10%,
    ${(0, ui_theme_1.fromTheme)('color_background_disabled_form_input')} 18%,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 33%
  );
  background-size: 1000px 640px;
  height: 100%;
  position: relative;
`;
exports.LocationsList = styled_1.default.ol `
  list-style: none;
  padding: 0;
  counter-reset: item;
  margin-bottom: 0;
`;
exports.LocationWrapper = styled_1.default.li `
  margin: 0;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  padding-left: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  border-bottom: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  counter-increment: item;
  position: relative;

  &:last-child {
    padding-bottom: 0;
  }

  > div:first-of-type {
    font-size: ${(0, ui_theme_1.fromTheme)('font_size')};

    > strong {
      padding-bottom: 0;
    }

    > strong > a,
    > strong {
      font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
      padding-top: 0;
    }
  }

  &:before {
    content: counter(item);
    font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    position: absolute;
    left: 4px;
    top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }

  &:last-of-type {
    border-bottom: none;
  }
`;
exports.LocationRow = (0, styled_1.default)('ul') `
  padding: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  display: flex;
  flex-wrap: wrap;

  &:first-of-type {
    padding-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }

  > li {
    list-style: none;
    &:not(:first-of-type):before {
      ${(props) => (0, dot_spacer_styles_1.dotSpacer)({
    marginLeft: (0, ui_theme_1.fromTheme)('spacing_small')(props),
    marginRight: (0, ui_theme_1.fromTheme)('spacing_small')(props)
})}
    }
  }

  &:last-of-type {
    padding-bottom: 0px;
    @media only screen and (max-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
      margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    };
  }
}
`;
exports.LocationInfoItem = styled_1.default.span `
  list-style: none;
  margin: 0;
  color: ${(0, ui_theme_1.fromTheme)('color_text')};

  .contact-label {
    text-transform: capitalize;
  }

  ${({ noPrint }) => noPrint &&
    `@media print {
      display: none;
    }`}
`;
exports.LocationPhoneAnchor = styled_1.default.a `
  color: ${(0, ui_theme_1.fromTheme)('color_link')};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
exports.LocationAddressRow = (0, styled_1.default)('span') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  line-height: 1.6;
`;
exports.LocationHeaderContainer = (0, styled_1.default)('div') `
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  > *:last-child {
    margin-right: 0;
  }
`;
//# sourceMappingURL=styles.js.map